module.exports = __webpack_public_path__ + "img/img_04@2x.4eb2321b.png";